import { useErrorHandlingQuery } from '@backoffice-frontend/data-fetching'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { useLeafletMapLineServiceConfigQuery } from '../../graphql/query/leafletMapLineServiceConfig.hook'

/**
 * Whether line service is enabled for the given service area. The config query
 * is forbidden without a line service right, so it is skipped (and treated as
 * disabled) instead of surfacing a "Missing permissions" error.
 */
export const useIsLineServiceEnabled = (serviceAreaId?: string) => {
  const canAccessLineService = useUserHasAccess({
    allowedRights: [
      BoumRight.STOP_NETWORK_LINE_SERVICE_CRUD,
      BoumRight.STOP_NETWORK_LINE_SERVICE_R,
    ],
  })
  const { data } = useErrorHandlingQuery(useLeafletMapLineServiceConfigQuery, {
    variables: { serviceAreaId: serviceAreaId ?? '' },
    skip: !serviceAreaId || !canAccessLineService,
  })

  return data?.lineServiceConfig.enabled ?? false
}
